import React, { Component, Fragment } from "react";
import { Row } from "reactstrap";

import { Colxx, Separator } from "../../../components/common/CustomBootstrap";
import Breadcrumb from "../../../containers/navs/Breadcrumb";

import RestrictedGeofences from "../../../containers/reports2/restricted-geofences";

class GeofenceAnalytics extends Component {
  render() {
    return (
      <Fragment>
        <Row>
          <Colxx xxs="12">
            <Breadcrumb heading="menu.restricted-geofence" match={this.props.match} />
            <Separator className="mb-5" />
          </Colxx>
        </Row>

        <RestrictedGeofences />
      </Fragment>
    );
  }
}
export default GeofenceAnalytics;
